









































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'

import { OverlayPanel } from 'primevue/overlaypanel'
import Zoom from '../components/Zoom.vue'

@Component({
  components: {
    Zoom
  }
})
export default class ActionsMenu extends Vue {
  @Prop({ default: false }) readonly disableRestore!: boolean
  @Prop({ default: false }) readonly disableClear!: boolean

  @Ref() readonly menu!: OverlayPanel

  @Watch('selectedSendReportStatus')
  public sendReportStatusSelected () {
    this.$emit('selectedSendReportStatus', this.selectedSendReportStatus)
  }

  private actionName = ''
  private emitName = ''
  private confirmationMessage = ''
  private actionConfirmationModal = false
  private selectedSendReportStatus = 'success'
  private sendReportStatuses = [
    { name: 'Success', code: 'success' },
    { name: 'Fail', code: 'fail' }
  ]

  public toggleActionsMenu (event: any) {
    // If the icon is clicked, target the button to blur
    if (event.target.tagName === 'BUTTON') {
      event.target.blur()
    } else {
      event.path[1].blur()
    }

    this.menu.toggle(event)
  }

  public dataActionClickHandler (emitName: string, actionName: string) {
    // Close menu overlaypanel
    this.menu.hide()

    this.emitName = emitName
    this.actionName = actionName.toLowerCase()
    this.confirmationMessage =
      `Are you sure you want to ${this.actionName}
      the ${this.actionName === 'restore' ? 'last' : ''} report?`

    this.actionConfirmationModal = true
  }

  public actionCancelConfirmation () {
    this.actionConfirmationModal = false
  }

  public actionConfirmation () {
    this.$emit(this.emitName)

    this.actionConfirmationModal = false
  }
}
